import React, { memo } from 'react'

import type { Height, Variant } from '../../../themes'
import { StyledProgressIndicator, StyledProgressRoot } from './Progress.styles'

export interface ProgressProps {
  'data-e2e'?: string
  className?: string
  height?: Height
  max?: number
  value: number
  variant?: Variant
}

const Progress = ({
  'data-e2e': dataE2e = 'progress',
  className,
  height = '0.5rem',
  max = 100,
  value,
  variant = 'primary',
}: ProgressProps) => (
  <StyledProgressRoot
    $height={height}
    $variant={variant}
    className={className}
    data-e2e={dataE2e}
    max={max}
    value={value}
  >
    <StyledProgressIndicator $max={max} $variant={variant} $value={value} />
  </StyledProgressRoot>
)

export default memo(Progress)
